/* Dependencies */
import styled from 'styled-components';

/* Components */
import { Button, Texter } from 'lego-dist';

/* Icons */
import { ReactComponent as RoundCheckmark } from 'images/icons/roundCheckmark.svg';

export const Container = styled.div.attrs(() => ({
  className: 'AddClassroomContainer',
}))`
  width: 100%;
  height: calc(100vh - 60px);
  padding: 20px 16px;

  overflow-y: scroll;

  & form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 100%;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    height: auto;
    padding: 20px;
  }
`;

export const Content = styled.div.attrs(() => ({
  className: 'AddClassroomForm',
}))`
  color: ${({ theme }) => theme.colors.darkGray};
  font-weight: bold;

  display: flex;
  flex-direction: column;
  justify-content: center;

  & p {
    font-size: 16px;
    padding: 0;
    margin: 0;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    margin-bottom: 20px;

    & p {
      font-size: 18px;
    }
  }
`;

export const Label = styled.label.attrs(() => ({
  className: 'AddClassroomLabel',
}))`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const CharCount = styled.div.attrs(() => ({
  className: 'AddClassroomCharCount',
}))`
  color: ${({ theme }) => theme.colors.shadeMedium};
  font-size: 12px;
  font-weight: normal;
`;

export const PhotoUploaderContainer = styled.div<any>`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin: 30px auto;

  .legoAvatarPhoto {
    width: 120px;
    height: 120px;
  }
  .legoAvatarSkeleton {
    margin-top: 5px;
    padding: 0;
  }
`;

export const ErrorMessage = styled.div.attrs(() => ({
  className: 'AddClassroomError',
}))`
  color: #ef4b48;
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 5px;
`;

export const TextInput = styled(Texter)`
  > input {
    height: 40px;
    width: 100%;

    border: 1px solid ${({ theme }) => theme.colors.shadeMedium};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.shadeMediumDark} !important;
    font-size: 16px !important;
    font-weight: normal;
    line-height: 16px;
    padding: 0 0 0 12px;

    &:focus {
      border: 1px solid ${({ theme }) => theme.colors.physicalLight30};
    }
  }

  & .texter-error {
    color: #ef4b48;
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 20px;
    margin-top: 5px;
  }
`;

export const BtnWrapper = styled.div.attrs(() => ({
  className: 'AddClassroomButtons',
}))`
  display: flex;
  justify-content: flex-end;
`;

export const NextBtn = styled(Button).attrs(() => ({
  className: 'AddClassroomNext',
}))`
  width: 120px;
`;

export const Illustration = styled(RoundCheckmark).attrs(() => ({
  className: 'AddClassroomSuccessIllustration',
}))`
  height: 60px;
  width: 60px;
  margin-bottom: 30px;

  & #fill {
    fill: #75b753;
  }

  & #checkmark {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const Wrapper = styled.div.attrs(() => ({
  className: 'AddClassroomWrapper',
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 40px;
`;

export const Caption = styled.div.attrs(() => ({
  className: 'AddClassroomCaption',
}))`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 20px;
`;

export const AgeInfo = styled.div.attrs(() => ({
  className: 'AgeInfo',
}))`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

export const AgeTitle = styled.h4.attrs(() => ({
  className: 'AgeTitle',
}))`
  margin-bottom: 5px;
`;

export const AgeText = styled.p.attrs(() => ({
  className: 'AgeText',
}))`
  margin: 0px !important;
  font-size: 14px !important;
  font-weight: normal;
`;

export const AgeContainer = styled.div.attrs(() => ({
  className: 'AgeContainer',
}))`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 15px;
`;

export const AgeItem = styled.div.attrs(() => ({
  className: 'AgeItem',
}))`
  width: 45%;
`;

export const AgeInputs = styled.div.attrs(() => ({
  className: 'AgeInputs',
}))`
  display: flex;
  justify-content: space-between;
`;
